import React from "react";

const PoweredByFooter = () => {
  return (
    <div className="fixed bottom-4 right-4 z-50">
      <a
        href="https://expertaid.com"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-2 bg-white/90 backdrop-blur-sm px-3 py-2 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-200 hover:scale-105"
      >
        <span className="text-xs text-gray-600">Powered by</span>
        <div className="flex items-center gap-1">
          <div className="w-6 h-6 bg-gradient-to-br from-blue-500 to-purple-600 rounded flex items-center justify-center">
            <span className="text-white font-bold text-xs">E</span>
          </div>
          <span className="text-sm font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
            Expertaid
          </span>
        </div>
      </a>
    </div>
  );
};

export default PoweredByFooter;
